const alertDialog = require('../alert-dialog/alert-dialog.js');

document.addEventListener("DOMContentLoaded", function () {
    const _idLoadMoreBtn = 'loadMoreNotificationsBtn';
    const _cnCenterSection = '.notification_center_section';
    const _cnCenterContainerList = `${_cnCenterSection} .notification_center_container_list`;
    const _cnButtonSection = `.notification_button_section`;
    const _cnIconButtonHeader = `${_cnButtonSection} .support-navigation__item.support-navigation__item--login a`;
    const _cnIconBadgeHeader = `${_cnButtonSection} .notification_badge_container`;
    const _cnDigestBoxBackdrop = `${_cnButtonSection} .notification_digest_box_backdrop`;
    const _cnDigestBoxList = `${_cnButtonSection} .notification_digest_box .notification_digest_box_list`;
    const _cnDigestBoxShown = 'notification_digest_box__shown';
    const _cnIconCardContainer = '.notification_icon_card_container';
    const _cnIconCardDefaultMaxWith = `${_cnIconCardContainer}.default_max_width`;
    const _cnIconCardLastBlueBtn = `${_cnIconCardContainer}.is_last.blue_button`;
    const _cnIconCardMarkAllReadBtn = `${_cnIconCardContainer}.mark_all_read_button .notification_icon_card__mark-read-all-button`;
    const _cnIconCardImageContainer = `${_cnIconCardContainer} .notification_icon_card__img_container`;
    const _cnIconCardInfoContainer = `${_cnIconCardContainer} .notification_icon_card__info_container`;

    const _removeLoadMoreNotificationButton = function () {
        //const _loadMoreBtn = document.getElementById(_idLoadMoreBtn);
        //const _parent = _loadMoreBtn.closest(_cnIconCardLastBlueBtn);

        //if (_parent) {
        //    _parent.remove();
        //}

        const _loadMoreBtn = document.getElementById(_idLoadMoreBtn);

        if (_loadMoreBtn) {
            const _parent = _loadMoreBtn.closest(_cnIconCardLastBlueBtn);
            if (_parent) {
                _parent.remove();
            }
        }
    }

    const _removeAllNotifications = function (fromHeader) {
        let _elements;
        if (fromHeader) {
            _elements = document.querySelectorAll(`${_cnDigestBoxList} ${_cnIconCardContainer}`);
        } else {
            _elements = document.querySelectorAll(`${_cnCenterContainerList} ${_cnIconCardContainer}`);
        }

        if (_elements) {
            for (let _element of _elements) {
                if (_element) {
                    _element.remove();
                }
            }
        }
    }

    const _getAmountOfNotifications = function () {
        const _amount = document.querySelectorAll(_cnIconCardDefaultMaxWith);

        return !!_amount ? _amount.length : 0;
    }

    const _updateCardStates = function (fromHeader, classToBeAdded) {
        if (fromHeader) {
            const _elements = document.querySelectorAll(_cnButtonSection);
            for (let _element of _elements) {
                _element.classList.remove('has_notifications');
                _element.classList.remove('no_notifications');
                _element.classList.remove('error_notifications');
                _element.classList.remove('show_loading');

                if (classToBeAdded) {
                    _element.classList.add(classToBeAdded);
                }
            }
        } else {
            const _elements = document.querySelectorAll(_cnCenterSection);
            for (let _element of _elements) {
                _element.classList.remove('show_error_msg');
                _element.classList.remove('show_empty_msg');
                _element.classList.remove('show_loading');
                _element.classList.remove('show_loading_complete');

                if (classToBeAdded) {
                    _element.classList.add(classToBeAdded);
                }
            }
        }
    }

    const _getDataOfNotificationCenter = function (updateNotifications) {
        if (document.querySelector(_cnCenterSection)) {
            _getNotifications(false, _setLoadMoreBtn, updateNotifications);
        }
    }

    const _getNotifications = function (fromHeader, callBack, updateNotifications) {
        let _url = `/umbraco/surface/dtnanotification/getnotifications?fh=${fromHeader}`;
        const _skip = updateNotifications ? 0 : _getAmountOfNotifications();

        if (fromHeader) {
            _updateCardStates(fromHeader, 'show_loading');
        } else {
            _url += `&take=10&skip=${_skip}`;
            _updateCardStates(fromHeader, updateNotifications ? 'show_loading_complete' : 'show_loading');
        }

        const request = new XMLHttpRequest();
        request.open("GET", _url, true);

        const errorHandler = function () {
            if (fromHeader) {
                if (_skip === 0) {
                    _updateCardStates(fromHeader, 'no_notifications');
                } else {
                    _updateCardStates(fromHeader, 'error_notifications');
                }
            } else {
                if (_skip === 0) {
                    _updateCardStates(fromHeader, 'show_error_msg');
                } else {
                    _updateCardStates(fromHeader, 'show_empty_msg');
                }
            }

            if (callBack) {
                callBack();
            }
        }

        request.addEventListener("load", function () {
            if (request.readyState === request.DONE && request.status === 200) {
                if (updateNotifications) {
                    _removeAllNotifications(fromHeader);
                }

                if (fromHeader) {
                    _updateCardStates(fromHeader);
                } else {
                    _removeLoadMoreNotificationButton();
                    _updateCardStates(fromHeader);
                }

                const _elements = document.querySelectorAll(fromHeader ? _cnDigestBoxList : _cnCenterContainerList);
                for (let _element of _elements) {
                    _element.insertAdjacentHTML('beforeend', request.responseText);
                }

                if (callBack) {
                    callBack();
                }
            } else {
                errorHandler();
            }
        });
        request.addEventListener("error", () => errorHandler());
        request.send();
    }

    const _hasUnReadNotifications = function (callBack) {
        const request = new XMLHttpRequest();
        request.open("GET", '/umbraco/api/dtnanotificationapi/hasunreadnotifications', true);
        request.responseType = 'json';

        const removeHasNotifications = function () {
            const _elements = document.querySelectorAll(_cnButtonSection);
            for (let _element of _elements) {
                _element.classList.remove("has_notifications");
            }

            return _elements;
        }

        const errorHandler = function () {
            removeHasNotifications();

            if (callBack) {
                callBack();
            }
        }

        request.addEventListener("load", function () {
            if (request.readyState === request.DONE && request.status === 200) {
                const _elements = removeHasNotifications();
                if (!_elements.values().every(e => e.classList.contains('no_notifications')) && request.response === true) {
                    for (let _element of _elements) {
                        _element.classList.add("has_notifications");
                    }
                }

                if (callBack) {
                    callBack();
                }
            } else {
                errorHandler();
            }
        });
        request.addEventListener("error", () => errorHandler());
        request.send();
    }

    const _setLoadMoreBtn = function () {
        const _loadMoreBtn = document.getElementById(_idLoadMoreBtn);

        if (_loadMoreBtn) {
            _loadMoreBtn.removeEventListener('click', () => { });
            _loadMoreBtn.addEventListener('click', function () {
                _getNotifications(false, _setLoadMoreBtn);
            });
        }

        _setCardsClick();
    }

    const _setButtonAndBadgesHeader = function () {
        const _elements = document.querySelectorAll(`${_cnIconButtonHeader}, ${_cnIconBadgeHeader}, ${_cnDigestBoxBackdrop}`);

        if (_elements && _elements[0]) {
            for (let _element of _elements) {
                _element.removeEventListener('click', () => { });
                _element.addEventListener('click', function () {
                    const _sections = document.querySelectorAll(_cnButtonSection);

                    if (_sections) {
                        for (let _section of _sections) {
                            if (_section.classList.contains(_cnDigestBoxShown)) {
                                _section.classList.remove(_cnDigestBoxShown);
                            } else {
                                _section.classList.add(_cnDigestBoxShown);
                            }
                        }
                    }
                });
            }

            _getNotifications(true, function () {
                _hasUnReadNotifications(_setCardsClick);
            });
        }
    }

    const _updateNotificationRead = function (fromHeader, _idNotification) {
        _updateCardStates(fromHeader, fromHeader ? 'show_loading' : 'show_loading_complete');

        if (_idNotification) {
            const request = new XMLHttpRequest();
            request.open("POST", '/umbraco/api/dtnanotificationapi/updatenotification', true);
            request.responseType = 'text';
            request.setRequestHeader('Content-type', 'application/json');

            const errorHandler = function () {
                alertDialog.showDtnaAlertDialog('Error', 'Fail to navigate to this notification. Please try later.');
                _updateCardStates(fromHeader);
            }

            request.addEventListener("load", function () {
                if (request.readyState === request.DONE && request.status === 200) {
                    window.location.href = request.responseText;
                } else {
                    errorHandler();
                }
            });
            request.addEventListener("error", () => errorHandler());
            request.send(JSON.stringify({ id: _idNotification }));
        }
    }

    const _updateAllNotificationsRead = function () {
        _updateCardStates(true, 'show_loading');

        const request = new XMLHttpRequest();
        request.open("POST", '/umbraco/api/dtnanotificationapi/markallreadnotification', true);
        request.responseType = 'json';
        request.setRequestHeader('Content-type', 'application/json');

        const errorHandler = function () {
            alertDialog.showDtnaAlertDialog('Error', 'Fail to mark all notifications as read. Please try later.');
            _getNotifications(true, function () {
                _hasUnReadNotifications(_setCardsClick);
            }, true);
            _getDataOfNotificationCenter(true);
        }

        request.addEventListener("load", function () {
            if (request.readyState === request.DONE && request.status === 200) {
                if (!request.response) {
                    alertDialog.showDtnaAlertDialog('Error', 'Fail to mark all notifications as read. Please try later.');
                }

                _getNotifications(true, function () {
                    _hasUnReadNotifications(_setCardsClick);
                }, true);
                _getDataOfNotificationCenter(true);

            } else {
                errorHandler();
            }
        });
        request.addEventListener("error", () => errorHandler());
        request.send();
    }

    const _setCardsClick = function () {
        let _elements = document.querySelectorAll(`${_cnDigestBoxList} ${_cnIconCardImageContainer}, ${_cnDigestBoxList} ${_cnIconCardInfoContainer}`);
        if (_elements) {
            for (let _element of _elements) {
                _element.removeEventListener('click', () => { });
                _element.addEventListener('click', function () {
                    _updateNotificationRead(true, this.dataset.notificationId);
                });
            }
        }

        _elements = document.querySelectorAll(`${_cnCenterContainerList} ${_cnIconCardImageContainer}, ${_cnCenterContainerList} ${_cnIconCardInfoContainer}`);
        if (_elements) {
            for (let _element of _elements) {
                _element.removeEventListener('click', () => { });
                _element.addEventListener('click', function () {
                    _updateNotificationRead(false, this.dataset.notificationId);
                });
            }
        }

        _setMarkAllReadClick();
    }

    const _setMarkAllReadClick = function () {
        const _elements = document.querySelectorAll(_cnIconCardMarkAllReadBtn);

        if (_elements) {
            for (let _element of _elements) {
                _element.removeEventListener('click', () => { });
                _element.addEventListener('click', function () {
                    _updateAllNotificationsRead();
                });
            }
        }
    }

    const _init = function () {
        _setButtonAndBadgesHeader();
        _getDataOfNotificationCenter();
    }

    if (document.readyState == "complete") {
        _init();
    } else {
        window['addEventListener']("load", _init, 0);
    }
});
